import { NsjAuthInstance } from '../authentication/nsj-autenticacao';
import { configInstance } from '@core/configuracao/nsj-config';
import { Http2ServerRequest } from 'http2';

/**
 * Sistema de origem declarado à API do Meu RH. O backend usa o header para ocultar e barrar
 * ações do Workflow restritas a outros sistemas (ex.: estorno de Movimentações, só no Persona).
 */
const SISTEMA_ORIGEM = 'MEURH';

export class HttpInterceptorService {
    private static _instance: HttpInterceptorService;
    private origemApi: string | null = null;

    public static Factory() {
        HttpInterceptorService._instance = new HttpInterceptorService();

        return HttpInterceptorService._instance;
    }

    request = (config: Http2ServerRequest) => {
        // seto token no header de Authorization
        config.headers['Authorization'] = NsjAuthInstance.nsjAuth.token;

        // só para a API do Meu RH: outros domínios (autenticação, assinatura etc.) não liberam
        // o header no CORS e recusariam o preflight
        if (this.isRequisicaoApi(config.url)) {
            config.headers['sistema'] = SISTEMA_ORIGEM;
        }

        return config;
    }

    responseError = (rejection : Response) => {
        if (rejection.status === 401) {
            (<any>window).location = NsjAuthInstance.nsjAuth.createLogoutUrl();
        }

        return Promise.reject(rejection);
    }

    /**
     * A API é a mesma origem da URL de rotas (fosrouting) da configuração.
     */
    private isRequisicaoApi(url: string): boolean {
        const origemApi = this.getOrigemApi();

        if (!origemApi || !url) {
            return false;
        }

        try {
            return new URL(url, window.location.href).origin === origemApi;
        } catch (e) {
            return false;
        }
    }

    private getOrigemApi(): string | null {
        if (this.origemApi) {
            return this.origemApi;
        }

        try {
            this.origemApi = new URL(configInstance.config.routing.url).origin;
        } catch (e) {
            return null;
        }

        return this.origemApi;
    }
}
